import { FC } from 'react';
import { Skeleton } from '@storybook';

interface LoadingSkeletonProps {
	isSettingPage?: boolean;
}

export const LoadingSkeleton: FC<LoadingSkeletonProps> = ({ isSettingPage = false }) => {
	return (
		<>
			{!isSettingPage && (
				<div className="connected-client_header-wrapper">
					<Skeleton width={200} height={20} />
					<div className="connected-client_header-action">
						<Skeleton width={150} height={20} />
						<Skeleton width={180} height={20} />
					</div>
				</div>
			)}
			<div className="connected-client_wrapper">
				<div className="connected-client_header">
					<div className="connected-client_header-wrapper">
						<div 
							className="connected-client_logo" 
							style={{ padding: '0', backgroundColor: 'transparent' }}
						>
							<Skeleton width={40} height={40} borderRadius={100} />
						</div>
						<div className="connected-client_info-content">
							<div className="connected-client_title">
								<Skeleton width={200} height={16} />
							</div>
							<div className="connected-client_subtitle">
								<Skeleton width={120} height={14} />
							</div>
						</div>
					</div>
				</div>
			</div>
		</>
	);
}; 